import { render, staticRenderFns } from "./settlementList.vue?vue&type=template&id=1b121352&"
import script from "./settlementList.vue?vue&type=script&lang=js&"
export * from "./settlementList.vue?vue&type=script&lang=js&"
import style0 from "./settlementList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports